var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7271_4859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8385 26.6175C44.8385 26.6175 44.8385 26.6067 44.8385 26.5959C44.9143 26.4117 44.9577 26.2167 44.9577 26C44.9577 25.7834 44.9143 25.5884 44.8385 25.4042C44.8385 25.4042 44.8385 25.3934 44.8385 25.3825C44.7518 25.1767 44.6327 25.0034 44.481 24.8517L31.481 11.8517C30.8418 11.2125 29.8127 11.2125 29.1843 11.8517C28.5452 12.4909 28.5452 13.52 29.1843 14.1484L39.411 24.375H8.66602C7.76685 24.375 7.04102 25.1009 7.04102 26C7.04102 26.8992 7.76685 27.625 8.66602 27.625H39.411L29.1843 37.8517C28.5452 38.4909 28.5452 39.52 29.1843 40.1484C29.4985 40.4625 29.921 40.625 30.3327 40.625C30.7443 40.625 31.1668 40.4625 31.481 40.1484L44.481 27.1484C44.6327 26.9967 44.7518 26.8125 44.8385 26.6175Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7271_4859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLRight);
export default __webpack_public_path__ + "static/media/Arrow-L-Right.49f613cd87f959979dc9b2c26b0c5fb6.svg";
export { ForwardRef as ReactComponent };